import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-rules-list',
  templateUrl: './rules-list.component.html',
  styleUrls: ['./rules-list.component.scss'],
})
export class RulesListComponent extends BaseListCtl {
  //Contains application id
  public applicationId: number = 0;
  public isPagingShow: boolean = false;
  public testform: any = {
    error: false, //error
    message: '', //error or success message
    preload: null, // preload data
    inputerror: {}, // form input error messages
    data: { id: 0 }, //form data
  };

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
  ) {
    super('', locator, route);
    locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        this.initApiEndpoint(property);
      });
    let _self = this;
    _self.applicationId = Number(this.route.snapshot.paramMap.get('appId'));
    _self.form.data['appId'] = _self.applicationId;
    _self.form.searchParams['appId'] = _self.applicationId;

    let keySuffix = localStorage.getItem('keySuffix');
    let storedUserContext = keySuffix
      ? localStorage.getItem(keySuffix + 'userContext')
      : null;

    let existingUserContext = storedUserContext
      ? JSON.parse(storedUserContext)
      : {};
    let orgId = existingUserContext.orgId;

    // ✅ Add orgId only when applicationId is not available
    if (!_self.applicationId) {
      _self.form.searchParams['orgId'] = orgId;
    }
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.code = data.code;
    form.rule = data.rule;
  }

  override ngOnInit() {
    //this.resetForm();
    this.form.searchParams['appId'] = this.applicationId;
    this.search();
  }

  override search(): void {
    let _self = this;
    _self.form.searchParams['appId'] = _self.applicationId;
    super.search();
  }

  override save(): void {
    let _self = this;
    _self.form.data['applicationId'] = _self.applicationId;
    super.save();
    setTimeout(() => {
      this.resetForm();
    }, 1000);
  }

  ngOnChanges() {}

  override resetForm() {
    let _self = this;
    super.resetForm();
    _self.form.data['applicationId'] = _self.applicationId;
  }

  isNullOrBlank(value: any) {
    return value === null || value.trim() === '';
  }

  execute(operation: any): void {
    let _self = this;
    _self.testform.data['operationType'] = operation;
    _self.testform.data['input'] = _self.input_data;
    _self.testform.result = null;
    let url =
      _self.locator.config.get('endpoint.application.rules') +
      '/' +
      'execute/' +
      _self.testform.data['id'];
    _self.locator.http.post(
      url,
      _self.testform.data,
      function (res: any, error: any) {
        if (error) {
          return;
        }
        _self.testform.error = !res.success;
        _self.testform.message = res.result.message;
        _self.testform.result = _self.processResponse(res);
        _self.testform.success = res.success;
        console.log('FORM', _self.testform);
      },
    );
  }

  // onSelectRow(selectedId: string) {
  //   let _self = this;
  //   if (selectedId !== '0') {
  //     const selectedItem = this.form.list.find(
  //       (c: any) => c.id.toString() === selectedId,
  //     );
  //     if (selectedItem) {
  //       console.log('Found item:', selectedItem); // Log the found item
  //       _self.testform.data['rule'] = selectedItem['rule'];
  //     } else {
  //       console.log('Item not found');
  //     }
  //   } else {
  //     console.log('No item selected');
  //   }
  // }

  onSelectRow(selectedId: any) {
    let _self = this;
    // Ensure we are comparing strings to strings
    const idStr = selectedId ? selectedId.toString() : '0';

    if (idStr !== '0') {
      const selectedItem = this.form.list.find(
        (c: any) => c.id.toString() === idStr,
      );
      if (selectedItem) {
        _self.testform.data['rule'] = selectedItem['rule'];
      }
    }
  }

  // setTestData(row: any) {
  //   this.testform.data['id'] = row.id;
  //   this.testform.data['rule'] = row.rule;

  //   this.input_data = {};
  //   this.inputKeys = []; // Array to store dynamic keys
  //   this.inputCounter = 0;
  // }

  setTestData(row: any) {
    // Force ID to string so mat-select matches it correctly
    this.testform.data['id'] = row.id.toString();
    this.testform.data['rule'] = row.rule;

    this.input_data = {};
    this.inputKeys = [];
    this.inputCounter = 0;

    // Explicitly call the selection logic to ensure the rule displays immediately
    this.onSelectRow(this.testform.data['id']);
  }
  compareFn(o1: any, o2: any): boolean {
    return (
      o1 !== undefined && o2 !== undefined && o1.toString() === o2.toString()
    );
  }

  public searchRuleItem: string = '';
  /**
   *
   * @returns Filter useacases
   */
  public filterUsecases(): any {
    let searchTerm = this.searchRuleItem.toLowerCase();
    return this.form.list.filter((e: any) =>
      (e['name'] + '').toLowerCase().includes(searchTerm),
    );
  }

  processResponse(response: any): void {
    let result: any;
    if (response.success) {
      // If `success` is true, format the `data` property for display
      const data = response.result.data;

      // Check if data contains both list and JSON
      if (Array.isArray(data)) {
        result = data
          .map((item) =>
            typeof item === 'object' ? JSON.stringify(item, null, 2) : item,
          )
          .join('\n');
      } else {
        result = JSON.stringify(data, null, 2); // For purely JSON data
      }
    } else {
      // If `success` is false, show error message or placeholder
      result = 'No data available or request failed.';
    }

    return result;
  }

  input_data: any = {};
  inputKeys: string[] = []; // Array to store dynamic keys
  inputCounter = 0;
  delete1(id: any) {
    if (this.form.list.length == 1) {
      this.form.list = [];
    }
    this.delete(id);
    this.resetForm();
  }
  addInput(): void {
    const newKey = `input${this.inputCounter}`; // New key for the object
    this.inputKeys.push(newKey); // Add new key to inputKeys array
    this.input_data[newKey] = ''; // Initialize the value with an empty string
    this.inputCounter++; // Increment the counter for the next key
  }

  // Remove an input key-value pair
  // removeInput(index: number): void {
  //   const keyToRemove = this.inputKeys[index];
  //   this.inputKeys.splice(index, 1); // Remove key from inputKeys array
  //   delete this.input_data[keyToRemove]; // Remove key-value from input_data
  // }
  ruleName = false;

  public async checkValue(event: Event): Promise<void> {
    console.log('I am in check Value is method');
    const input = event.target as HTMLInputElement; // Cast event target as input element
    const value = this.normalizeSpaces(input.value.trim()); // Normalize spaces and trim leading/trailing spaces
    console.log(value);
    this.form.data['name'] = value === '' ? null : this.capitalizeWords(value);
    if (!this.form.data['name']) {
      console.log('In side error');
      this.form.data['name'] = undefined;
      this.form.inputerror['name'] = 'Name is Required';
      this.ruleName = true;
    } else {
      this.ruleName = false;
      this.form.inputerror['name'] = null;
    }
  }

  /**
   * Normalize spaces in a string to ensure only one space between words.
   * @param str - Input string to normalize.
   * @returns Normalized string with single spaces.
   */
  normalizeSpaces(str: string): string {
    return str.replace(/\s+/g, ' '); // Replace multiple spaces with a single space
  }

  /**
   * Capitalize the first letter of each word in a string, allowing words with all uppercase characters.
   * @param str -
   * @returns
   */
  capitalizeWords(str: string): string {
    return str
      .split(' ') // Split the string by spaces
      .map(
        (word) =>
          word === word.toUpperCase() // Check if all characters are uppercase
            ? word
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(), // Otherwise, capitalize the first letter
      )
      .join(' '); // Join the array back into a string with spaces
  }
}
